import { ValidatorFn, UntypedFormControl } from '@angular/forms';
import moment from 'moment';

export class MinimumDOBValidator {    
  
    static minimumAge(age: number): ValidatorFn {
      return (control: UntypedFormControl): { [key: string]: any } => {        

        if (control.valid) {
      
          const day = control.value.split('/')[1];
          const month = control.value.split('/')[0];
          const year = control.value.split('/')[2];
          const date = moment({ year: year, month: (+month) - 1, day: day }).startOf('day');

          if (date.isValid()) {
            
            const now = moment().startOf('day');            
            const yearsDiff = date.diff(now, 'years');

            if (yearsDiff > -age) {
              return { requiredAge: false };                
            }
            return null;
            }
         }
      };        
   }
}
  